import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=47a39be9&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a39be9"]])

export default __exports__